import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const WORKER_URL = "https://reflex-backend.alfaoir1.workers.dev"; // 🔁 Replace with your actual Worker URL

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  * { margin:0; padding:0; box-sizing:border-box; }

  body {
    background:#f5f5f7;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
    color:#111;
  }

  @keyframes fadeIn {
    from { opacity:0; transform:translateY(16px); }
    to { opacity:1; transform:translateY(0); }
  }

  @keyframes pulseGlow {
    0%, 100% { box-shadow: 0 0 0 0 rgba(109,40,217,0.3), 0 4px 20px rgba(109,40,217,0.2); }
    50% { box-shadow: 0 0 0 6px rgba(109,40,217,0), 0 4px 32px rgba(109,40,217,0.35); }
  }

  @keyframes shimmer {
    0% { background-position: -200% center; }
    100% { background-position: 200% center; }
  }

  @keyframes scanline {
    0% { transform: translateY(-100%); }
    100% { transform: translateY(100vh); }
  }

  @keyframes borderPulse {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
  }

  @keyframes gridFade {
    from { opacity:0; }
    to { opacity:1; }
  }

  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }

  .btn-animated {
    background: linear-gradient(135deg, #6d28d9, #7c3aed, #a855f7, #7c3aed);
    background-size: 300% 100%;
    color:#fff;
    border: none;
    padding:15px 32px;
    border-radius:999px;
    cursor:pointer;
    font-weight:700;
    font-size:15px;
    display:inline-flex;
    align-items:center;
    gap:10px;
    font-family: "Inter", sans-serif;
    animation: shimmer 3s linear infinite, pulseGlow 2.5s ease-in-out infinite;
    transition: transform 0.2s, opacity 0.2s;
    letter-spacing: 0.01em;
  }
  .btn-animated:hover:not(:disabled) { transform: scale(1.04); }
  .btn-animated:disabled { cursor: not-allowed; opacity: 0.7; }

  .form-bg {
    min-height: 100vh;
    background: #f5f5f7;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px 100px;
    animation: gridFade 0.6s ease;
  }

  .form-bg::before {
    content: '';
    position: fixed;
    inset: 0;
    background-image:
      linear-gradient(rgba(109,40,217,0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(109,40,217,0.05) 1px, transparent 1px);
    background-size: 48px 48px;
    pointer-events: none;
    z-index: 0;
  }

  .form-bg::after {
    content: '';
    position: fixed;
    top: 0; left: 0; right: 0;
    height: 3px;
    background: linear-gradient(90deg, transparent, #7c3aed, #a855f7, #7c3aed, transparent);
    animation: borderPulse 3s ease-in-out infinite;
    z-index: 10;
  }

  .scan-line {
    position: fixed;
    top: 0; left: 0; right: 0;
    height: 140px;
    background: linear-gradient(to bottom, transparent, rgba(109,40,217,0.025), transparent);
    animation: scanline 10s linear infinite;
    pointer-events: none;
    z-index: 1;
  }

  .form-inner {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 700px;
  }

  .form-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 0 32px;
    border-bottom: 1px solid rgba(109,40,217,0.12);
    margin-bottom: 40px;
  }

  .back-btn {
    background: #fff;
    border: 1px solid rgba(109,40,217,0.2);
    color: #6d28d9;
    cursor: pointer;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.2s;
    font-family: "Inter", sans-serif;
    letter-spacing: 0.02em;
    font-weight: 600;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  }
  .back-btn:hover { background: #f3eeff; border-color: #7c3aed; color: #7c3aed; }

  .form-hero-block {
    text-align: center;
    margin-bottom: 48px;
    animation: fadeIn 0.6s ease;
  }

  .cyber-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid rgba(109,40,217,0.2);
    color: #7c3aed;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    padding: 7px 16px;
    border-radius: 4px;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 1px 6px rgba(109,40,217,0.1);
  }

  .cyber-badge::before {
    content: '';
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 3px;
    background: #7c3aed;
    box-shadow: 0 0 6px rgba(124,58,237,0.5);
  }

  .cyber-dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #7c3aed;
    box-shadow: 0 0 5px rgba(124,58,237,0.6);
    animation: pulseGlow 2s ease-in-out infinite;
  }

  .form-title {
    font-size: 42px;
    font-weight: 900;
    letter-spacing: -1.5px;
    line-height: 1.05;
    margin-bottom: 12px;
    color: #111;
  }

  .form-title span { color: #7c3aed; }

  .form-subtitle {
    font-size: 14px;
    color: rgba(0,0,0,0.4);
    letter-spacing: 0.02em;
  }

  .progress-shell {
    background: rgba(109,40,217,0.08);
    border: 1px solid rgba(109,40,217,0.12);
    border-radius: 4px;
    height: 6px;
    width: 100%;
    margin-bottom: 8px;
    overflow: hidden;
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #6d28d9, #7c3aed, #a855f7);
    border-radius: 4px;
    transition: width 0.4s cubic-bezier(0.4,0,0.2,1);
    box-shadow: 0 0 10px rgba(124,58,237,0.4);
    position: relative;
  }

  .progress-fill::after {
    content: '';
    position: absolute;
    right: 0; top: 0; bottom: 0;
    width: 20px;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.5));
    border-radius: 4px;
  }

  .progress-meta {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: rgba(0,0,0,0.35);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 36px;
    font-weight: 600;
  }

  .progress-meta span:last-child { color: #7c3aed; font-weight: 700; }

  .contact-panel {
    background: #fff;
    border: 1px solid rgba(109,40,217,0.12);
    border-radius: 16px;
    padding: 28px;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 2px 16px rgba(0,0,0,0.05);
  }

  .contact-panel::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(124,58,237,0.4), transparent);
  }

  .panel-label {
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: rgba(109,40,217,0.6);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .panel-label::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(109,40,217,0.1);
  }

  .input-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .input-wrap { position: relative; }
  .input-wrap.full { grid-column: 1 / -1; }

  .field-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(109,40,217,0.55);
    margin-bottom: 6px;
    display: block;
  }

  .cyber-input {
    width: 100%;
    padding: 12px 14px;
    background: #f9f7ff;
    border: 1px solid rgba(109,40,217,0.15);
    border-radius: 8px;
    color: #111;
    font-size: 14px;
    font-family: "Inter", sans-serif;
    outline: none;
    transition: all 0.2s;
    box-sizing: border-box;
  }

  .cyber-input::placeholder { color: rgba(0,0,0,0.25); }
  .cyber-input:focus {
    border-color: #7c3aed;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(124,58,237,0.1);
  }

  .q-card {
    background: #fff;
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 12px;
    transition: border-color 0.3s, box-shadow 0.3s;
    position: relative;
    overflow: hidden;
    box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  }

  .q-card:hover { box-shadow: 0 4px 20px rgba(109,40,217,0.08); }

  .q-card.answered {
    border-color: rgba(109,40,217,0.2);
    background: #faf8ff;
    box-shadow: 0 2px 16px rgba(109,40,217,0.07);
  }

  .q-card.answered::before {
    content: '';
    position: absolute;
    top: 0; left: 0; bottom: 0;
    width: 3px;
    background: linear-gradient(to bottom, #6d28d9, #a855f7);
    box-shadow: 1px 0 8px rgba(124,58,237,0.3);
  }

  .q-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }

  .q-num {
    font-size: 10px;
    font-weight: 900;
    color: #7c3aed;
    background: rgba(124,58,237,0.08);
    border: 1px solid rgba(124,58,237,0.2);
    border-radius: 6px;
    padding: 4px 10px;
    letter-spacing: 0.08em;
    flex-shrink: 0;
    font-family: "Inter", monospace;
  }

  .q-category {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(0,0,0,0.3);
  }

  .q-check {
    margin-left: auto;
    width: 20px; height: 20px;
    border-radius: 50%;
    background: rgba(34,197,94,0.1);
    border: 1px solid rgba(34,197,94,0.4);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }

  .q-text {
    font-size: 15px;
    font-weight: 600;
    color: #111;
    line-height: 1.5;
    letter-spacing: -0.01em;
    margin-bottom: 16px;
  }

  .opts-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .opt {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 10px;
    cursor: pointer;
    text-align: left;
    font-size: 13.5px;
    font-family: "Inter", sans-serif;
    transition: all 0.15s ease;
    width: 100%;
    letter-spacing: -0.01em;
    position: relative;
    overflow: hidden;
  }

  .opt-indicator {
    width: 8px; height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    transition: all 0.15s;
  }

  .submit-zone {
    margin-top: 32px;
    padding: 32px;
    background: #fff;
    border: 1px solid rgba(109,40,217,0.12);
    border-radius: 20px;
    text-align: center;
    position: relative;
    overflow: hidden;
    box-shadow: 0 2px 20px rgba(109,40,217,0.07);
  }

  .submit-zone::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(124,58,237,0.4), transparent);
  }

  .submit-stats {
    display: flex;
    justify-content: center;
    gap: 32px;
    margin-bottom: 24px;
  }

  .stat-item { text-align: center; }
  .stat-val { font-size: 28px; font-weight: 900; color: #7c3aed; letter-spacing: -1px; display: block; }
  .stat-key { font-size: 10px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(0,0,0,0.3); }

  .success-page {
    min-height: 100vh;
    background: #f5f5f7;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px 20px;
    animation: fadeIn 0.6s ease;
    position: relative;
    overflow: hidden;
  }

  .success-page::before {
    content: '';
    position: fixed;
    inset: 0;
    background-image:
      linear-gradient(rgba(109,40,217,0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(109,40,217,0.05) 1px, transparent 1px);
    background-size: 48px 48px;
    pointer-events: none;
  }

  .success-inner {
    position: relative; z-index: 2;
    max-width: 500px; width: 100%;
  }

  .success-icon {
    width: 80px; height: 80px;
    border-radius: 24px;
    background: #fff;
    border: 1px solid rgba(124,58,237,0.2);
    display: flex; align-items: center; justify-content: center;
    font-size: 36px;
    margin: 0 auto 28px;
    animation: float 3s ease-in-out infinite;
    box-shadow: 0 8px 32px rgba(124,58,237,0.15);
  }
`;

const Arrow = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M2 7h10M7 2l5 5-5 5" stroke="white" strokeWidth="1.5"/>
  </svg>
);

const BackArrow = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M12 7H2M7 2L2 7l5 5" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2 5l2.5 2.5L8 3" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const clickSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    o.type = "sine";
    o.frequency.setValueAtTime(880, ctx.currentTime);
    o.frequency.exponentialRampToValueAtTime(440, ctx.currentTime + 0.08);
    g.gain.setValueAtTime(0.12, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);
    o.start(ctx.currentTime);
    o.stop(ctx.currentTime + 0.12);
  } catch(e) {}
};

const questions = [
  { key:"q1",  label:"Growth Support",
    sub:"What type of support would help your business grow most right now?",
    opts:[
      {c:"#7c3aed",t:"Internal team management only"},
      {c:"#2563eb",t:"Strategic guidance from experienced operators"},
      {c:"#d97706",t:"Hands-on execution support for growth systems"},
      {c:"#16a34a",t:"Full external support across sales, marketing, and operations"},
    ]},
  { key:"q2",  label:"Sales Structure",
    sub:"How is your sales function currently structured?",
    opts:[
      {c:"#7c3aed",t:"Managed internally with existing team"},
      {c:"#2563eb",t:"Partially structured but inconsistent"},
      {c:"#d97706",t:"Needs stronger sales system and process design"},
      {c:"#16a34a",t:"Requires complete sales system build and execution"},
    ]},
  { key:"q3",  label:"Lead Generation",
    sub:"What best describes your current lead generation?",
    opts:[
      {c:"#7c3aed",t:"Mostly referrals and manual outreach"},
      {c:"#2563eb",t:"Paid ads with inconsistent results"},
      {c:"#d97706",t:"Multiple sources but not optimized"},
      {c:"#16a34a",t:"Needs a fully scalable lead generation system"},
    ]},
  { key:"q4",  label:"Automation Level",
    sub:"What level of automation is your business currently using?",
    opts:[
      {c:"#7c3aed",t:"No automation in place"},
      {c:"#2563eb",t:"Basic tools (spreadsheets / manual CRM use)"},
      {c:"#d97706",t:"Partial automation (follow-ups or booking systems)"},
      {c:"#16a34a",t:"Full automation across leads, sales, and operations"},
    ]},
  { key:"q5",  label:"Tech & Systems",
    sub:"Do you require any custom systems to run your business?",
    opts:[
      {c:"#7c3aed",t:"No, current tools are enough"},
      {c:"#2563eb",t:"Minor improvements needed"},
      {c:"#d97706",t:"Advanced CRM / workflow upgrades needed"},
      {c:"#16a34a",t:"Full custom web system (dashboard, tracking, internal tools)"},
    ]},
  { key:"q6",  label:"Marketing",
    sub:"How is your marketing currently handled?",
    opts:[
      {c:"#7c3aed",t:"Fully in-house"},
      {c:"#2563eb",t:"Mixed internal and external support"},
      {c:"#d97706",t:"Needs better structure and performance optimization"},
      {c:"#16a34a",t:"Needs fully managed marketing system"},
    ]},
  { key:"q7",  label:"Operations",
    sub:"How would you describe your operations system?",
    opts:[
      {c:"#7c3aed",t:"Fully manual processes"},
      {c:"#2563eb",t:"Semi-structured workflows"},
      {c:"#d97706",t:"Some systems but inconsistent execution"},
      {c:"#16a34a",t:"Needs complete operational system design"},
    ]},
  { key:"q8",  label:"Leadership",
    sub:"What level of leadership support would help your business most?",
    opts:[
      {c:"#7c3aed",t:"No external leadership needed"},
      {c:"#2563eb",t:"Occasional consulting support"},
      {c:"#d97706",t:"Strategic advisory support"},
      {c:"#16a34a",t:"Fractional executive support (sales / marketing / operations leadership)"},
    ]},
  { key:"q9",  label:"Scaling Goal",
    sub:"What is your main goal for the next 6–12 months?",
    opts:[
      {c:"#7c3aed",t:"Stability and consistency"},
      {c:"#2563eb",t:"Gradual growth"},
      {c:"#d97706",t:"Fast expansion"},
      {c:"#16a34a",t:"Full enterprise-level scaling"},
    ]},
  { key:"q10", label:"Execution",
    sub:"What best describes your ability to execute growth initiatives?",
    opts:[
      {c:"#7c3aed",t:"Fully handled internally"},
      {c:"#2563eb",t:"Limited capacity, some bottlenecks"},
      {c:"#d97706",t:"Need additional skilled support"},
      {c:"#16a34a",t:"Need fully managed execution system"},
    ]},
  { key:"q11", label:"Job Consistency",
    sub:"What best describes your current job flow consistency?",
    opts:[
      {c:"#7c3aed",t:"Consistently busy with no gaps"},
      {c:"#2563eb",t:"Busy but occasional slow periods"},
      {c:"#d97706",t:"Unpredictable weeks (ups and downs)"},
      {c:"#16a34a",t:"Struggle to maintain consistent booked work"},
    ]},
  { key:"q12", label:"Lead Quality",
    sub:"What is your biggest issue with current leads/jobs?",
    opts:[
      {c:"#7c3aed",t:"Leads are good and profitable"},
      {c:"#2563eb",t:"Leads come in but quality is inconsistent"},
      {c:"#d97706",t:"Enough leads, but not enough high-paying commercial jobs"},
      {c:"#16a34a",t:"Struggle to get consistent high-quality, high-profit work"},
    ]},
];

export default function PrivateAccessForm() {
  const navigate = useNavigate();

  const [contact, setContact] = useState({
    fullName: "",
    company: "",
    email: "",
    phone: "",
    serviceArea: "",
  });
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const answered = Object.keys(answers).length;
  const progress = (answered / questions.length) * 100;
  const pct = Math.round(progress);

  const handleContact = (e) => {
    setContact(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const select = (key, idx) => {
    clickSound();
    setAnswers(prev => ({ ...prev, [key]: idx }));
  };

  const handleSubmit = async () => {
    // Basic validation
    if (!contact.fullName.trim() || !contact.email.trim()) {
      alert("Please enter your full name and email before submitting.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...contact,
        answers: Object.fromEntries(
          questions.map(q => [
            q.key,
            answers[q.key] !== undefined ? q.opts[answers[q.key]].t : null,
          ])
        ),
      };

      const res = await fetch(`${WORKER_URL}/junkbid-form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (!data.success) throw new Error(data.error || "Unknown error");

      setSubmitted(true);
    } catch (err) {
      console.error(err);
      alert("Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <>
        <style>{css}</style>
        <div className="success-page">
          <div className="scan-line" />
          <div className="success-inner">
            <div className="success-icon">🚀</div>
            <div className="cyber-badge" style={{ margin:"0 auto 20px" }}>
              <span className="cyber-dot" />
              Submission Received
            </div>
            <h2 style={{ fontSize:32, fontWeight:900, letterSpacing:"-1px", marginBottom:12, color:"#111" }}>
              Assessment <span style={{ color:"#7c3aed" }}>Complete</span>
            </h2>
            <p style={{ color:"rgba(0,0,0,0.45)", fontSize:14, lineHeight:1.7, marginBottom:32 }}>
              We've received your {answered}/{questions.length} responses.<br/>
              Our team will analyse your profile and reach out within 24–48 hours.
            </p>
            <div style={{ display:"flex", gap:16, justifyContent:"center", flexWrap:"wrap", marginBottom:32 }}>
              {[["12", "Questions"], ["48h", "Response"], ["100%", "Private"]].map(([v,k],i) => (
                <div key={i} style={{ textAlign:"center", background:"#fff", border:"1px solid rgba(124,58,237,0.15)", borderRadius:12, padding:"16px 24px", boxShadow:"0 2px 12px rgba(0,0,0,0.05)" }}>
                  <span style={{ fontSize:24, fontWeight:900, color:"#7c3aed", letterSpacing:"-1px", display:"block" }}>{v}</span>
                  <span style={{ fontSize:10, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"rgba(0,0,0,0.3)" }}>{k}</span>
                </div>
              ))}
            </div>
            <button className="btn-animated" onClick={() => navigate("/")}>
              Back to Home <Arrow />
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{css}</style>
      <div className="form-bg">
        <div className="scan-line" />
        <div className="form-inner">

          {/* Topbar */}
          <div className="form-topbar">
            <button className="back-btn" onClick={() => navigate(-1)}>
              <BackArrow /> Back
            </button>
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <span style={{ fontSize:10, fontWeight:700, letterSpacing:"0.12em", textTransform:"uppercase", color:"rgba(0,0,0,0.3)" }}>
                System Access
              </span>
              <span style={{ width:6, height:6, borderRadius:"50%", background:"#16a34a", boxShadow:"0 0 5px rgba(22,163,74,0.5)", display:"inline-block" }} />
              <span style={{ fontSize:10, fontWeight:700, letterSpacing:"0.12em", textTransform:"uppercase", color:"#16a34a" }}>Online</span>
            </div>
          </div>

          {/* Hero block */}
          <div className="form-hero-block">
            <div className="cyber-badge">
              <span className="cyber-dot" />
              JunkBid Intelligence System
            </div>
            <h1 className="form-title">
              Growth &amp; Systems<br /><span>Assessment</span>
            </h1>
            <p className="form-subtitle">No clutter — just decision-making clarity</p>
          </div>

          {/* Progress */}
          <div className="progress-shell">
            <div className="progress-fill" style={{ width:`${progress}%` }} />
          </div>
          <div className="progress-meta">
            <span>Profile Completion</span>
            <span>{pct}% — {answered}/{questions.length} modules</span>
          </div>

          {/* Contact panel */}
          <div className="contact-panel">
            <div className="panel-label">Operator Identity</div>
            <div className="input-grid">
              <div className="input-wrap">
                <label className="field-label">Full Name *</label>
                <input
                  className="cyber-input"
                  name="fullName"
                  value={contact.fullName}
                  onChange={handleContact}
                  placeholder="John Doe"
                />
              </div>
              <div className="input-wrap">
                <label className="field-label">Company</label>
                <input
                  className="cyber-input"
                  name="company"
                  value={contact.company}
                  onChange={handleContact}
                  placeholder="ABC Hauling LLC"
                />
              </div>
              <div className="input-wrap">
                <label className="field-label">Email *</label>
                <input
                  className="cyber-input"
                  name="email"
                  value={contact.email}
                  onChange={handleContact}
                  placeholder="you@email.com"
                  type="email"
                />
              </div>
              <div className="input-wrap">
                <label className="field-label">Phone</label>
                <input
                  className="cyber-input"
                  name="phone"
                  value={contact.phone}
                  onChange={handleContact}
                  placeholder="+1 (000) 000-0000"
                  type="tel"
                />
              </div>
              <div className="input-wrap full">
                <label className="field-label">Service Area</label>
                <input
                  className="cyber-input"
                  name="serviceArea"
                  value={contact.serviceArea}
                  onChange={handleContact}
                  placeholder="City, State"
                />
              </div>
            </div>
          </div>

          {/* Questions */}
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {questions.map((item, qi) => {
              const isAnswered = answers[item.key] !== undefined;
              return (
                <div key={item.key} className={`q-card${isAnswered ? " answered" : ""}`}>
                  <div className="q-header">
                    <span className="q-num">Q{String(qi+1).padStart(2,"0")}</span>
                    <span className="q-category">{item.label}</span>
                    {isAnswered && (
                      <div className="q-check"><CheckIcon /></div>
                    )}
                  </div>
                  <p className="q-text">{item.sub}</p>
                  <div className="opts-wrap">
                    {item.opts.map((opt, oi) => {
                      const active = answers[item.key] === oi;
                      return (
                        <button
                          key={oi}
                          className="opt"
                          onClick={() => select(item.key, oi)}
                          style={{
                            border: active ? `1.5px solid ${opt.c}` : "1px solid rgba(0,0,0,0.07)",
                            background: active ? `${opt.c}12` : "rgba(0,0,0,0.01)",
                            color: active ? "#111" : "rgba(0,0,0,0.55)",
                            fontWeight: active ? 600 : 400,
                          }}
                        >
                          <span
                            className="opt-indicator"
                            style={{
                              background: active ? opt.c : "rgba(0,0,0,0.15)",
                              boxShadow: active ? `0 0 6px ${opt.c}80` : "none",
                            }}
                          />
                          {opt.t}
                          {active && (
                            <span style={{ marginLeft:"auto", fontSize:10, fontWeight:800, color:opt.c, letterSpacing:"0.08em", textTransform:"uppercase" }}>
                              Selected
                            </span>
                          )}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Submit zone */}
          <div className="submit-zone">
            <div className="submit-stats">
              {[
                [answered, "Answered"],
                [questions.length - answered, "Remaining"],
                [pct + "%", "Complete"],
              ].map(([v,k],i) => (
                <div key={i} className="stat-item">
                  <span className="stat-val">{v}</span>
                  <span className="stat-key">{k}</span>
                </div>
              ))}
            </div>
            <button
              className="btn-animated"
              style={{ width:"100%", justifyContent:"center", fontSize:15, padding:"16px 32px", borderRadius:12 }}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Transmitting…" : "Transmit Assessment"} <Arrow />
            </button>
            <p style={{ marginTop:14, fontSize:11, color:"rgba(0,0,0,0.25)", letterSpacing:"0.05em" }}>
              ENCRYPTED · PRIVATE · REVIEWED WITHIN 48H
            </p>
          </div>

        </div>
      </div>
    </>
  );
}